// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"C138_EmbeddableForm_checkbox__jsjbs","tick":"C138_EmbeddableForm_tick__1KS2a"};